import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core';

import { SignaletiqueService } from 'src/app/service/signalitique.service';
import { Signaletique } from 'src/app/entity/signalitique';
import { Observable } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
declare var jsPDF: any;
@Component({
  selector: 'app-signalitique',
  templateUrl: './signalitique.component.html',
  styleUrls: ['./signalitique.component.css']
})
export class SignalitiqueComponent implements OnInit, OnChanges {
  types: SelectItem[];

  signaletiques: Signaletique[];
  @ViewChild('dt' ) DataTableVar: Table;
  signaletiquesO: Observable<Signaletique[]>;
  cols: any[];
  colsToExport: any[];
  @Input() index: number;
  exportColumns: any[];
  _selectedColumns: any[];

  constructor(private signaletiqueService: SignaletiqueService) {
    this.types = [
      { label: 'Tout', value: '' },
      { label: 'Oui', value: 'true' },
      { label: 'Non', value: 'false' }
    ];
  }

  ngOnInit() {



    this.cols = [
      { field: 'ownerName', header: 'Raison Social', width: '25%' },
      { field: 'logo', header: 'Logo', width: '5%' },

      { field: 'signalitique', header: 'Signalétique', width: '10%' },
      { field: 'fax', header: 'Prix Pub', width: '5%' },
      { field: 'pub', header: 'Pub', width: '5%' },
      { field: 'email', header: 'Stands', width: '10%' },
      { field: 'nameTri', header: 'Concrétisé par', width: '10%' },
      { field: 'signalitiqueSent', header: 'Sent to Exposign', width: '10%' },
      { field: 'viwPlan', header: 'Logo recu', width: '10%' },

      { field: 'pubSent', header: 'Pub Recu', width: '10%' },
      { field: 'viw', header: 'Signlétique Recu', width: '10%' },


    ];
    this._selectedColumns = this.cols;
    this.colsToExport = [
      { field: 'ownerName', header: 'Raison Social', width: '25%' },


      { field: 'signalitique', header: 'Signalétique', width: '10%' },
      { field: 'fax', header: 'Prix Pub', width: '5%' },

      { field: 'email', header: 'Stands', width: '10%' },





    ];
    this.exportColumns = this._selectedColumns.map(col => ({ title: col.header, dataKey: col.field }));
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    this.exportColumns = this._selectedColumns.map(col => ({ title: col.header, dataKey: col.field }));
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.index == 3 && !this.signaletiquesO) {
      this.signaletiquesO = this.signaletiqueService.getAllBySalon(56);
      this.signaletiquesO.subscribe(result => {
        this.signaletiques = result;
      }

      )
    }

  }
  exportPdf() {


    var doc = new jsPDF('l');



    doc.filename = "cwxc";
    if (this.DataTableVar.filteredValue)
      doc.autoTable(

        this.exportColumns, this.DataTableVar.filteredValue, {


        margin: { vertical: 17, horizontale: 17 },

        columnStyles: { 0: { columnWidth: 50 }, 1: { columnWidth: 40 }, 2: { columnWidth: 40 } }
      });
    else doc.autoTable(
      this.exportColumns, this.signaletiques, {


      margin: { vertical: 17, horizontale: 17 },

      columnStyles: { 0: { columnWidth: 50 }, 1: { columnWidth: 40 }, 2: { columnWidth: 40 }, }
    });

    doc.save('Liste des hotels.pdf');


  }
  exportExcel() {

    const doc = new jsPDF('l');
    doc.filename = "cwxc";
    if (this.DataTableVar.filteredValue)
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.getItems(this.DataTableVar.filteredValue));
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "stand_list");
      });
    else import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.getItems(this.signaletiques));
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "stand_list");
    });



  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

 
  getItems(items: Signaletique[]) :Item[]{
    let cars: Item[] = [];

    for (let index = 0; index < items.length; index++) {
      const element = items[index];
      let item = new Item();

      if (element.OwnerName)
      item.Client = element.OwnerName.toString();
 
 
      cars.push(item);
    }




    return cars;
  }
}

class Item {
  Stand: any;
  Client: any;
  Superficie:string;
  Type:string
}